import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { CrownIcon, CheckIcon } from "@phosphor-icons/react";
import { PLAN_NAMES, PLAN_PRICES, UPGRADE_EVENT } from "@/lib/plans";

const PERKS = {
  pro: ["Unlimited Ask Gamly questions", "Live Game Companion feed", "All 8 AI modes + predictions", "Card watchlist + unlimited Fan Memory"],
  press_box_pro: ["Everything in Pro Fan", "Real-time talking points + stat packs", "Pregame / postgame reports", "Interview + press conference tools"],
};

// Global upgrade prompt, opened by any 402 response or openUpgrade().
export default function UpgradeDialog() {
  const [detail, setDetail] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const onUpgrade = (e) => setDetail(e.detail || { required_plan: "pro" });
    window.addEventListener(UPGRADE_EVENT, onUpgrade);
    return () => window.removeEventListener(UPGRADE_EVENT, onUpgrade);
  }, []);

  const plan = detail?.required_plan || "pro";
  const accent = plan === "press_box_pro" ? "#FDB927" : "#0A84FF";
  const go = () => {
    setDetail(null);
    navigate(`/pricing?plan=${plan}`);
  };

  return (
    <Dialog open={!!detail} onOpenChange={(o) => !o && setDetail(null)}>
      <DialogContent className="bg-[#0f0f0f] border border-white/15 text-white max-w-md" data-testid="upgrade-dialog">
        <CrownIcon weight="fill" size={32} style={{ color: accent }} />
        <DialogTitle className="font-display font-bold text-3xl uppercase tracking-tighter" data-testid="upgrade-dialog-title">
          {detail?.code === "daily_limit" ? "Daily limit reached" : `Unlock with ${PLAN_NAMES[plan]}`}
        </DialogTitle>
        <DialogDescription className="text-white/65 text-sm" data-testid="upgrade-dialog-message">
          {detail?.message || `This feature is part of ${PLAN_NAMES[plan]}.`}
          {detail?.code === "daily_limit" && " Free questions reset every day at midnight UTC."}
        </DialogDescription>
        <ul className="space-y-1.5 my-2">
          {PERKS[plan].map((p) => (
            <li key={p} className="flex items-start gap-2 text-sm text-white/80">
              <CheckIcon weight="bold" size={14} className="mt-1 shrink-0" style={{ color: accent }} /> {p}
            </li>
          ))}
        </ul>
        <div className="flex gap-2 pt-2">
          <button
            onClick={go}
            data-testid="upgrade-dialog-cta"
            className="flex-1 py-3 rounded-md text-xs font-black uppercase tracking-wider transition-colors"
            style={{ backgroundColor: accent, color: plan === "press_box_pro" ? "#000" : "#fff" }}
          >
            Upgrade to {PLAN_NAMES[plan]} · {PLAN_PRICES[plan]}
          </button>
          <button
            onClick={() => setDetail(null)}
            data-testid="upgrade-dialog-dismiss"
            className="px-4 py-3 rounded-md border border-white/15 text-xs font-bold uppercase tracking-wider text-white/70 hover:text-white"
          >
            Not now
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
